
  __webpack_public_path__ = window.__FABRICS__.PUBLIC_PATH.resetPassword
  import('./resetPassword-bootstrap.js')
  